// Logout.js
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../actions";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false); // ダイアログの開閉状態を管理

  useEffect(() => {
    setOpen(true); // コンポーネントがマウントされたときにダイアログを開く
  }, []);

  const handleLogoutConfirm = () => {
    dispatch(logout()); // ログアウトアクションをディスパッチ
    navigate("/host/login"); // ログアウト後のリダイレクト先
  };

  const handleClose = () => {
    setOpen(false);
    navigate(-1); // 前のページに戻る
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>ログアウトしますか？</DialogTitle>
      <DialogContent></DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          キャンセル
        </Button>
        <Button onClick={handleLogoutConfirm} color="primary" autoFocus>
          ログアウト
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Logout;
